import React from 'react';
import { Button } from '@lightspeed/flame/Button';
import Group from '@lightspeed/cirrus-group';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/cirrus-modal';
import { VoidSaleEffectOnPayments } from './VoidSale';

export default class VoidSaleModal extends React.Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.voidSale = this.voidSale.bind(this);

    this.state = {
      showModal: true,
    };
  }

  /**
   * Action when closing the modal
   */
  close() {
    this.setState(
      {
        showModal: false,
      },
      () => {
        // In case the animation end was not triggered
        setTimeout(() => {
          this.props.renderedComponent.unmount();
        }, 250);
      }
    );
  }

  voidSale() {
    window.merchantos.controls.customFunctionOnClick(document.getElementById('voidSaleButton'), {
      name: 'void_sale_fnc',
      pannel_id: 'view',
      context: 'view',
      confirm_msg: '',
      prevent_repeat: false,
      save_on_changes: false,
      extra: null,
    });

    this.close();
  }

  render() {
    return (
      <Modal className="cirrus" isOpen={this.state.showModal} onRequestClose={this.close}>
        <ModalHeader onCloseClicked={this.close}>
          Void Sale <var>#{this.props.saleID}</var>
        </ModalHeader>
        <ModalBody>
          <div className="modal-container">
            <p>
              <strong>Warning!</strong> This action is permanent and can&#39;t be undone.
            </p>
            <p>Voiding this sale:</p>
            <ul id="void-sales-warning-list">
              <li>Removes all records of this transaction from the sales history</li>
              <li>Restores all relevant inventory levels</li>
              {this.props.effectOnPayment === VoidSaleEffectOnPayments.WILL_REFUND && (
                <li>Refunds all payments attached to this transaction</li>
              )}
              {this.props.effectOnPayment === VoidSaleEffectOnPayments.WILL_NOT_REFUND && (
                <li>Will not return money to the Customer&#39;s card</li>
              )}
            </ul>
          </div>
        </ModalBody>
        <ModalFooter>
          <Group className="cr-justify-end">
            <Button onClick={this.close}>Cancel</Button>
            <Button variant="danger" onClick={this.voidSale}>
              Void Sale
            </Button>
          </Group>
        </ModalFooter>
      </Modal>
    );
  }
}
